import React, { useEffect, useState } from "react";
import { Form, Formik, useField } from "formik";
import * as Yup from "yup";
import { Autocomplete, Button, TextField } from "@mui/material";
import { ButtonsContainer, FieldContainer, FormContainer, SectionContainer, SectionTitle } from "./CommunicationForm.styled";
import InputField from "../../../../components/formFields/InputField";
import DatePickerField from "../../../../shared/components/DatePickerField";
import { useCreateAssessmentClassAMutation, useCreateCommunicationMutation, useGetNaicMemberQuery, useGetLastBodyQuery } from "../../../../services/InsuranceService";
import dayjs from "dayjs";
import SearchableSelect from "../../../../components/formFields/SearchableSelect";
import { LoadingPanel } from "../../../../shared/components/LoadingPanel";
import useFetchWithMsal from "../../../../utils/useFetchWithMsal";

export const PreAssesmentForm = (props) => {
  const { onClose, data, type } = props;
  const { skip } = useFetchWithMsal();

  const [lastBody, setLastBody] = useState('');  
  const [initialNaicCode, setInitialNaicCode] = useState('');  
  const { data: body, refetch } = useGetLastBodyQuery();
  const { data: naicMembers, isLoading } = useGetNaicMemberQuery('', {});

  useEffect(() => {
    refetch();
  }, []);

  const transformedData = {...data, amount: data?.callAmountsAllocatedAnnuity}
  const initialValues = {
    naicCode: initialNaicCode,
    date: new Date(),
    emailSubject: "",
    body: lastBody,
  };

  useEffect(() => {
    setLastBody(body?.lastBody)
  }, [body]);

  useEffect(() => {
    naicMembers && setInitialNaicCode(naicMembers[0])
  }, [naicMembers?.length]);

  const [createCommunication, {isLoading: isAssesmentCreating}] = useCreateCommunicationMutation("");


  const validationSchema = Yup.object().shape({
    // premiumYear: Yup.string().required("Premium Year is required"),
    // title: Yup.string().required("Title is required"),
    // amount: Yup.number().required("Amount is required"),
  });

  const handleSubmit = (values) => {
    createCommunication({
      memberId: values.naicCode?.id === 0 ? 0 : values.naicCode?.id,
      // naicCode: values.naicCode?.naicCode,
      typeId: type,
      communicationDate: new Date(values.date),
      subject: values.emailSubject,
      body: values.body,
    })
    onClose()
  };

  const getInputComponent = (item) => {
    switch (item?.type) {
      case "text":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
            />
          </FieldContainer>
        );
      case "number":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              mode="numeric"
            />
          </FieldContainer>
        );
      case "amount":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              type="number"
            />
          </FieldContainer>
        );
      case "multiline":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              multiline
              type="textarea"
            />
          </FieldContainer>
        );
      case "date":
        return (
              <FieldContainer>
                <DatePickerField
                  name={item.name}
                  label={item.label}
                  maxDate={new Date()}
                  width={"100%"}
                  // disabled
                />
              </FieldContainer>
        );
      case "searchableSelect":
        return (
              <FieldContainer>
                <SearchableSelect
                  name={item.name}
                  label={item.label}
                  fullWidth
                  multiline
                  options={naicMembers}
                />
              </FieldContainer>
        );
      default:
        return null;
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, handleChange }) => (
        <Form>
          {isLoading || isAssesmentCreating && <LoadingPanel />}
          <FormContainer>
            <SectionContainer>
              {getInputComponent({
                name: "naicCode",
                label: "NAIC Code:",
                type: "searchableSelect",
              })}
              {getInputComponent({
                name: "date",
                label: "Date:",
                type: "date",
              })}
              {getInputComponent({
                name: "emailSubject",
                label: "Title:",
                type: "text",
              })}

              {getInputComponent({
                name: "body",
                label: "Body:",
                type: "multiline",
                rows: 4,
              })}

              <ButtonsContainer>
                <Button variant="outlined" type="submit">
                  Create Communication
                </Button>
                <Button variant="outlined" type="reset" onClick={onClose}>
                  Cancel
                </Button>
              </ButtonsContainer>
            </SectionContainer>
          </FormContainer>
        </Form>
      )}
    </Formik>
  );
};